import { render, staticRenderFns } from "./Documento.vue?vue&type=template&id=79582338&"
import script from "./Documento.vue?vue&type=script&lang=js&"
export * from "./Documento.vue?vue&type=script&lang=js&"
import style0 from "./Documento.vue?vue&type=style&index=0&id=79582338&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports